import * as Sentry from "@sentry/astro";

const debug = import.meta.env.PUBLIC_SENTRY_DEBUG === "true";

Sentry.init({
  dsn: import.meta.env.PUBLIC_SENTRY_DSN,
  environment: import.meta.env.DEV ? "development" : "production",
  enabled: import.meta.env.PROD || debug,
  debug,
  tracesSampleRate: 0.1,
  sendDefaultPii: false,
  integrations: [Sentry.browserTracingIntegration()],
});
